import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import ReactPixel from 'react-facebook-pixel';
const PIXEL_ID = '1323991343039911';
ReactPixel.init(PIXEL_ID);
ReactPixel.pageView();
render(<App data-id="element-465" data-mp="219624hpv1zcz" />, document.getElementById('root'));